import GoalCollapse from '../components/goals/GoalCollapse';
import LoadingIndicator from '../components/shared/LoadingIndicator';
import MilestoneList from "../components/goals/MilestoneList.js";
import * as React from "react";
import { useState } from "react";
import Flexbox from "flexbox-react";
import { observer } from "mobx-react";
import { NonIdealState } from "@blueprintjs/core";
import {
  FormGroup, Button, Drawer, Divider, Card,
  HTMLSelect,
  Position,
  Icon
} from "@blueprintjs/core";
import ThemeWrapper from "../components/styles/ThemeWrapper/index.js";
import LayoutHeader from "../components/layout/LayoutHeader";
import ToastStore from "../stores/ToastStore";
import CurrentUserStore from "../stores/CurrentUserStore";
import Cookies from "js-cookie";
import ErrorBoundary from "../components/errors/ErrorBoundary";
import { TextArea } from "@blueprintjs/core";
import axios from "axios";
import BlankPage from "../components/goals/BlankPage.js";
import FilledButton from "../components/buttons-20250224T111359Z-001/buttons/FilledButton.jsx";
import Utilities from "../utils/Utilities.js";
import goalIcon from "../assets/GoalIcon.svg";
import "../components/goals/GoalView.css";
import TextButton from "../components/buttons-20250224T111359Z-001/buttons/TextButton.jsx";
import ScrollableDropdown from "../components/shared/ScrollableDropdown.jsx";
import moment from "moment";
import { Classes, Tooltip } from "@blueprintjs/core";
import Progress from "../assets/Progress.svg";
import Weightage from "../assets/Weightage.svg";
import TimeLeft from "../assets/TimeLeft.svg";
import Comment1 from "../assets/Comment1.svg";
import Comment2 from "../assets/Comment2.svg";
import Subgoal from "../assets/Subgoal.svg";
import GoalProgressStatusBadge from "../components/goals/GoalProgressStatusBadge.js";
import GoalProgressRow from "../components/goals/GoalProgressRow.js";
import {
  getGoalProgressBarValue,
  getMatrixAchievedPercent,
  isGoalProgressSpecialAccount,
  parseProgressPercent,
  clampProgressBarValue,
  getGoalProgressMax
} from "../utils/goalProgressUtils.js";
import CascadingGoalsList from "../components/goals/CascadingGoalsList.js";
import { getGoalListState } from "../utils/goalListUtils.js";

@observer
export default class TeamGoalsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDropdownOpen: false,
      isEmployeeDropdownOpen: false,
      employeeList: [],
      allEmployeeList: [],
      selectedEmployee: {},
      goalCycleList: [],
      goalStatusList: [],
      selectedTimeframe: {},

      goalList: [],
      cascadingGoalList: [],
      editingGoal: {},
      isDrawerOpen: false,
      editingGoalId: null,
      selectedActionLabel: "Approve",
      // editingGoalIds: [],
      // editedGoals: {}
      isLoadingGoals: false,
      subGoalsByGoalId: {},
      openSubGoals: {},
    };

    this.employeeDropdownRef = React.createRef();
    this.goalCycleDropdownRef = React.createRef();
  }

  getUrlSelections = () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const encoded = params.get("r");

      if (!encoded) return null;

      const decoded = JSON.parse(atob(decodeURIComponent(encoded)));

      return {
        userId: decoded.u,
        goalSettingId: decoded.g
      };
    } catch (e) {
      console.error("Error decoding URL parameter", e);
      return null;
    }
  };

  getSessionSelections = () => {
    try {
      const raw = sessionStorage.getItem("team_goals_context");
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      console.error("Error reading sessionStorage", e);
      return null;
    }
  };

  getCookieSelections = () => {
    const selectedEmployeeId = Cookies.get("selectedEmployeeId");
    const selectedGoalCycleId = Cookies.get("selectedGoalCycleId");

    if (!selectedEmployeeId || !selectedGoalCycleId) return null;
    return {
      userId: selectedEmployeeId,
      goalSettingId: selectedGoalCycleId
    };
  };

  getActiveAccountId = () => CurrentUserStore?.activeAccount?.accountId ?? null;

  getProgressMax = () => getGoalProgressMax(this.getActiveAccountId());

  getStageConfig = (progress, metricValue) => {
    const percent = parseProgressPercent(progress);

    const config = {
      0: { label: "Not Started", value: 0, color: "#A1A5AD" },
      1: { label: "On Hold", value: 0, color: "#F2A724" },
      2: { label: "Not Completed", value: 0, color: "#E5453F" },
      3: { label: "In Progress", value: 50, color: "#2680EB" },
      4: { label: "Completed", value: 100, color: "#0f9960" },
      "not_started": { label: "Not Started", value: 0, color: "#A1A5AD" },
      "on_hold": { label: "On Hold", value: 0, color: "#F2A724" },
      "not_completed": { label: "Not Completed", value: 0, color: "#E5453F" },
      "in_progress": { label: "In Progress", value: 50, color: "#2680EB" },
      "completed": { label: "Completed", value: 100, color: "#0f9960" }
    };

    if (metricValue !== undefined && metricValue !== null && config[metricValue]) {
      return config[metricValue];
    }

    if (percent === 100) return config[4];
    if (percent === 50) return config[3];
    return config[0];
  };

  getActualProgressType = (goal) => {
    if (goal.metric_type === 1 || goal.metric_type === "stage") return "stage_wise";
    if (goal.metric_type === 2 || goal.metric_type === "number") return "number";
    if (goal.metric_type === 0 || goal.metric_type === "percentage") return "percentage";
    return goal.progress_type || this.getProgressType(goal.progress);
  };

  getProgressType = (progress) => {
    const percent = parseProgressPercent(progress);
    if ([0, 10, 50, 100, 90].includes(percent)) return "stage_wise";
    if (percent % 10 === 0 && percent <= 100 && percent >= 0) return "number";
    return "percentage";
  };

  goalHasSubGoals = (goalId) => {
    const subGoals = this.state.subGoalsByGoalId?.[goalId];
    return Array.isArray(subGoals) && subGoals.length > 0;
  };


  getStageName = (progress, metricValue) => {
    const percent = parseProgressPercent(progress);
    if (metricValue !== undefined && metricValue !== null) {
      const stageMap = {
        0: "Not Started",
        1: "On Hold",
        2: "Not Completed",
        3: "In Progress",
        4: "Completed",
        "not_started": "Not Started",
        "on_hold": "On Hold",
        "not_completed": "Not Completed",
        "in_progress": "In Progress",
        "completed": "Completed"
      };
      if (stageMap[metricValue]) return stageMap[metricValue];
    }

    if (percent === 100) return "Completed";
    if (percent === 50) return "In Progress";
    return "Not Started";
  };

  componentDidMount() {
    let selectionData = this.getUrlSelections();

    if (!selectionData) {
      selectionData = this.getSessionSelections();
    }

    if (!selectionData) {
      selectionData = this.getCookieSelections();
    }

    Promise.all([this.getAllGoalCycleList(), this.getSubordinatesEmployeeList()])
      .then(async () => {
        const { allEmployeeList, goalCycleList } = this.state;
        const nextState = {};

        if (selectionData?.userId) {
          const foundEmp = (allEmployeeList || []).find(
            e => String(e.id) === String(selectionData.userId)
          );
          if (foundEmp) {
            nextState.selectedEmployee = foundEmp;
          } else {
            const empName = Cookies.get("selectedEmployeeName");
            if (empName) {
              try {
                const res = await axios.get(`${Cookies.get("apiEnv")}/goals/employee/`, {
                  params: { search: empName }
                });
                const fetchedEmp = (res.data || []).find(e => String(e.id) === String(selectionData.userId));

                if (fetchedEmp) {
                  nextState.selectedEmployee = fetchedEmp;
                  const employeeMap = new Map((allEmployeeList || []).map(emp => [emp.id, emp]));
                  employeeMap.set(fetchedEmp.id, fetchedEmp);
                  nextState.allEmployeeList = Array.from(employeeMap.values());
                  nextState.employeeList = nextState.allEmployeeList;
                } else {
                  const mockEmp = { id: selectionData.userId, first_name: empName, last_name: "" };
                  nextState.selectedEmployee = mockEmp;
                  nextState.allEmployeeList = [mockEmp, ...allEmployeeList];
                  nextState.employeeList = nextState.allEmployeeList;
                }
              } catch (e) {
                console.error("Failed to fetch specific employee", e);
                const mockEmp = { id: selectionData.userId, first_name: empName, last_name: "" };
                nextState.selectedEmployee = mockEmp;
                nextState.allEmployeeList = [mockEmp, ...allEmployeeList];
                nextState.employeeList = nextState.allEmployeeList;
              }
            } else {
              const mockEmp = { id: selectionData.userId };
              nextState.selectedEmployee = mockEmp;
              nextState.allEmployeeList = [mockEmp, ...allEmployeeList];
              nextState.employeeList = nextState.allEmployeeList;
            }
          }
        }

        if (selectionData?.goalSettingId) {
          const foundCycle = (goalCycleList || []).find(
            gc => String(gc.id) === String(selectionData.goalSettingId)
          );
          if (foundCycle) {
            nextState.selectedTimeframe = foundCycle;
          }
        }

        if (selectionData) {
          sessionStorage.setItem("team_goals_context", JSON.stringify(selectionData));
        }

        if (Object.keys(nextState).length > 0) {
          this.setState(nextState, () => {
            this.fetchGoalsForSelectedEmployeeCycle();
            // this.fetchGoalsForSelectedCycle();
          });
        } else {
          this.fetchGoalsForSelectedEmployeeCycle();
          // this.fetchGoalsForSelectedCycle();
        }
      })
      .catch(error => console.error("Failed to fetch initial data", error));

    document.addEventListener("mousedown", this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside, true);
  }

  handleClickOutside = (event) => {
    const { isEmployeeDropdownOpen, isDropdownOpen } = this.state;
    const empNode = this.employeeDropdownRef ? this.employeeDropdownRef.current : null;
    const tfNode = this.goalCycleDropdownRef ? this.goalCycleDropdownRef.current : null;

    if (isEmployeeDropdownOpen && empNode && !empNode.contains(event.target)) {
      this.setState({ isEmployeeDropdownOpen: false });
    }
    if (isDropdownOpen && tfNode && !tfNode.contains(event.target)) {
      this.setState({ isDropdownOpen: false });
    }
  };

  getSubordinatesEmployeeList = () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${Cookies.get("apiEnv")}/goals/employee`)
        .then(response => {
          const employeeList = response.data || [];

          if (employeeList.length > 0) {
            this.setState(
              {
                employeeList,
                allEmployeeList: employeeList,
                selectedEmployee: employeeList[0]
              },
              resolve
            );
          } else {
            this.setState({ employeeList: [], allEmployeeList: [], selectedEmployee: {} }, resolve);
          }
        })
        .catch(error => {
          this.setState({ error: "Failed to load" });
          reject(error);
        });
    });
  };

  getAllGoalCycleList = () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${Cookies.get("apiEnv")}/goal_settings/goal_cycle_list`)
        .then(response => {
          const goalCycleList = response.data;

          if (goalCycleList.length > 0) {
            this.setState(
              {
                goalCycleList,
                selectedTimeframe: goalCycleList[0]
              },
              resolve
            );
          } else {
            this.setState({ goalCycleList: [], selectedTimeframe: {} });
          }
        })
        .catch(error => {
          this.setState({ error: "Failed to load" });
          reject(error);
        });
    });
  };

  fetchGoalsForSelectedEmployeeCycle = (showLoading = true) => {
    const { selectedTimeframe, selectedEmployee } = this.state;

    if (!selectedTimeframe.id || !selectedEmployee.id) {
      return;
    }

    if (showLoading) this.setState({ isLoadingGoals: true });

    const goalsRequest = axios
      .get(
        `${Cookies.get("apiEnv")}/goal_cascades/all_goals_list`, {
        params: {
          employee_id: selectedEmployee.id,
          goal_setting_id: selectedTimeframe.id,
          action_by_manager: true
        }
      }
      )
      .then(response => {
        const goalState = getGoalListState(response.data, { teamView: true });
        this.setState({ ...goalState, isLoadingGoals: false });
        return goalState;

      })

      .catch(error => {
        this.setState({ isLoadingGoals: false });
        console.error("Failed to load goals!", "danger");
      });

    if (selectedTimeframe.is_goal_progress_status) {
      axios
        .get(`${Cookies.get("apiEnv")}/goal_progress_states?goal_setting_id=${selectedTimeframe.id}`)
        .then(res => {
          if (Array.isArray(res.data)) {
            this.setState({ goalStatusList: res.data });
          }
        })
        .catch(err => {
          this.setState({ goalStatusList: [] });
        });
    }
    return goalsRequest;
  };

  fetchGoalsForSelectedCycle = () => {
    const { selectedTimeframe } = this.state;

    this.setState({ isLoading: true });
    axios
      .get(`${Cookies.get("apiEnv")}/goal_cascades/all_goals_list`, {
        params: {
          goal_setting_id: selectedTimeframe.id,
          //  ...this.getEmployeeParams()
        }
      })
      .then(response => {
        const data = response.data
        this.setState({ ...getGoalListState(data), isLoading: false });
      })
      .catch(error => {
        this.setState({ isLoading: false });
        ToastStore.showToast("Failed to load goals!", "danger");
      });

    if (selectedTimeframe.is_goal_progress_status) {
      axios
        .get(`${Cookies.get("apiEnv")}/goal_progress_states?goal_setting_id=${selectedTimeframe.id}`)
        .then(res => {
          if (Array.isArray(res.data)) {
            this.setState({ goalStatusList: res.data });
          }
        })
        .catch(err => {
          this.setState({ goalStatusList: [] });
        });
    }
  };

  handleSelectTimeframe = timeframe => {
    this.setState({ selectedTimeframe: timeframe, isDropdownOpen: false }, () => {
      this.fetchGoalsForSelectedEmployeeCycle();
      //this.fetchGoalsForSelectedCycle();
    });
  };

  handleBack = () => {
    if (window?.history?.length > 1) {
      window.history.back();
    } else {
      Utilities.navigate("/goals/tabs");
    }
  };

  handleSelectEmployee = employee => {
    this.setState(
      {
        selectedEmployee: employee,
        isEmployeeDropdownOpen: false,
        employeeList: this.state.allEmployeeList
      },
      () => {
        this.fetchGoalsForSelectedEmployeeCycle();
        // this.fetchGoalsForSelectedCycle();
      }
    );
  };

  toggleDropdown = () => {
    this.setState(prevState => ({ isDropdownOpen: !prevState.isDropdownOpen }));
  };

  toggleEmployeeDropdown = () => {
    this.setState(prevState => ({ isEmployeeDropdownOpen: !prevState.isEmployeeDropdownOpen }));
  };

  handleFileChange = event => {
    const file = event.target.files[0];
    if (file) {
      this.setState({
        currentGoal: {
          ...this.state.currentGoal,
          file
        }
      });
    }
  };

  handleSubmit = (goalId) => {
    const { editedGoals, editingGoal } = this.state;
    const updatedGoal = editingGoal;
    const payload = {};
    payload.goal_comment = updatedGoal.goal_comment;
    payload.id = updatedGoal.id;
    payload.goal_setting_id = updatedGoal.goal_setting_id;
    payload.goal_progress_state_id = updatedGoal.goal_progress_state_id;
    axios
      .put(`${Cookies.get("apiEnv")}/goals/${goalId}`, payload)
      .then(() => {
        ToastStore.showToast(`Goal updated successfully`, "success");
        this.setState(prevState => ({
          isDrawerOpen: false,
          editingGoal: null
        }));
        this.fetchGoalsForSelectedEmployeeCycle();
      })
      .catch(error => ToastStore.showToast(error, "danger"));
  };

  handleEditGoal = goal => {
    this.setState({
      editingGoal: goal,
      isDrawerOpen: true
    });
  };

  handleCancelGoal = goalId => {
    this.setState({
      editingGoal: null,
      isDrawerOpen: false
    });
  };

  handleGoalInputChange = (goalId, name, value) => {
    this.setState(prevState => {
      const updatedEditingGoal = {
        ...prevState.editingGoal,
        [name]: value
      };

      return {
        editingGoal: updatedEditingGoal
      };
    });

  };

  getEmployeeList = (searchQuery = "") => {
    const value = (searchQuery || "").trim();

    if (value.length === 0 || value.length < 3) {
      if (Array.isArray(this.state.allEmployeeList) && this.state.allEmployeeList.length > 0) {
        this.setState({
          employeeList: this.state.allEmployeeList
        });
        return;
      }
      this.getSubordinatesEmployeeList().catch(() => { });
      return;
    }

    axios
      .get(`${Cookies.get("apiEnv")}/goals/employee/`, {
        params: { search: value }
      })
      .then(response => {
        const fetchedEmployees = response.data || [];
        this.setState(prevState => {
          const employeeMap = new Map((prevState.allEmployeeList || []).map(emp => [emp.id, emp]));
          fetchedEmployees.forEach(emp => {
            if (emp && emp.id) employeeMap.set(emp.id, emp);
          });

          return {
            employeeList: fetchedEmployees,
            allEmployeeList: Array.from(employeeMap.values())
          };
        });
      })
      .catch(error => {
        ToastStore.showToast("Failed to load employees", "danger");
      });
  };

  handleEmployeeSearch = e => {
    if (e.key === "Enter" && e.target.value.length >= 3) {
      this.getEmployeeList(e.target.value);
    }
  };

  getStatusColor = value => {
    if (value === "Draft") return "#707070";
    else if (value === "Approved") return "#10A423";
    else if (value === "Rejected") return "#db3737";
    else if (value === "Pending") return "#D99B00";
    else return "#707070"
  };

  handleActionClick = (goalId, actionLabel) => {
    this.setState({ selectedActionLabel: actionLabel });

    if (actionLabel === "Approve") {
      this.handleSubmit(goalId, "Approved");
    } else if (actionLabel === "Reject") {
      this.handleSubmit(goalId, "Rejected");
    } else if (actionLabel === "Cancel") {
      this.handleCancelGoal(goalId);
    }
  };

  getDaysLeft = (goal) => {
    if (!goal.goal_end_at) return "";

    const today = moment();
    const endDate = moment(goal.goal_end_at);
    const diff = endDate.diff(today, "days");

    if (diff < 0) return "Expired";
    if (diff === 0) return "Ends today";

    return `${diff} days left`;
  };
  getDescriptionPreview = (description) => {
    if (!description) return "";
    const maxChars = 120;
    if (description.length <= maxChars) return description;
    return `${description.slice(0, maxChars)}... Read more`;
  };
  getEffectiveUserId = () => {
    return (
      Cookies.get("selectedEmployeeId") ||
      CurrentUserStore.currentUser.id
    );
  };

  getActiveAccountId = () => CurrentUserStore?.activeAccount?.accountId ?? null;

  canEditEmployeeGoal = (goal) => {
    return goal.is_goal_owner && this.state.selectedEmployee.id === goal.user_id;
  };

  render() {
    const {
      selectedTimeframe,
      isDropdownOpen,
      isEmployeeDropdownOpen,
      employeeList,
      selectedEmployee,
      isDrawerOpen,
      goalCycleList,
      editingGoal,
      cascadingGoalList,
      goalList,
      selectedActionLabel,
      goalStatusList,
      isLoadingGoals,
    } = this.state;
    const canCreateFromStore = !!CurrentUserStore?.hasAnyModulePermission?.('goals', ['write', 'create']);
    const isReadOnlyFromStore = !!CurrentUserStore?.isModuleReadOnly?.('goals');
    const rawPermsFromPermissions = CurrentUserStore?.permissions?.find?.(p => p?.module === 'goals')?.access_types ?? [];
    const rawPermsFromUser = CurrentUserStore?.currentUser?.permissions?.find?.(p => p?.module === 'goals')?.access_types ?? [];
    const raw = rawPermsFromPermissions.length ? rawPermsFromPermissions : rawPermsFromUser;
    const hasWriteRaw = Array.isArray(raw) && raw.includes('write');
    const canCreateRaw = hasWriteRaw || raw.includes('create');
    const isReadOnlyRaw = Array.isArray(raw) && raw.length === 1 && raw[0] === 'read';
    const isPermissionsEmpty = Array.isArray(CurrentUserStore?.permissions) && CurrentUserStore.permissions.length === 0;

    const canCreate = isPermissionsEmpty ? true : (canCreateFromStore || canCreateRaw);
    const isReadOnly = isPermissionsEmpty ? false : (isReadOnlyFromStore || isReadOnlyRaw);
    const filteredGoalCycles = goalCycleList.filter(gc => gc.id !== selectedTimeframe.id);
    const filteredEmployeeList = employeeList.filter(employee => employee.id !== selectedEmployee.id);


    return (
      <ThemeWrapper>
        <ErrorBoundary>
          <Flexbox flexGrow={1} width="100hw" alignContent="stretch" flexDirection="column">
            <Flexbox flexDirection="column" padding="20px" marginLeft="10px">
              <Flexbox
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
                style={{ gap: "16px" }}
              >
                <Flexbox alignItems="center" style={{ gap: "10px", minHeight: 40 }}>
                  <Icon icon="arrow-left" onClick={this.handleBack} className="arrow-icon" style={{ marginBottom: 24, cursor: "pointer" }}></Icon>
                  <Flexbox flexDirection="column">
                    <h3 style={{ fontSize: "20px", margin: 0 }}>Team Smart Goals</h3>
                    <span className="table-header-text" style={{ color: "#65748b", marginTop: 4 }}>
                      Add a new goal, Review team goals, monitor progress, and keep each cycle on track.
                    </span>
                  </Flexbox>
                </Flexbox>

                <Flexbox flexGrow={1} flexDirection="row" justifyContent="flex-end" alignItems="center">
                  {selectedTimeframe.is_editable && canCreate && !isReadOnly && (
                    <FilledButton
                      text="Add Goals"
                      style={{ marginTop: "23px" }}
                      onClick={() => {
                        // Cookies.set("selectedEmployeeId", selectedEmployee.id);
                        // // Cookies.set("selectedEmployeeName", selectedEmployee.first_name);
                        // Cookies.set("selectedGoalCycleId", selectedTimeframe.id);

                        Cookies.set("selectedEmployeeId", selectedEmployee.id);
                        Cookies.set("selectedEmplyeeAccountOwner", selectedEmployee.is_account_owner);

                        Cookies.set(
                          "selectedEmployeeName",
                          `${selectedEmployee.first_name || ""} ${selectedEmployee.last_name || ""}`.trim()
                        );

                        Cookies.set("selectedGoalCycleId", selectedTimeframe.id);

                        Utilities.navigate("/goals");
                      }}
                    />
                  )}
                  <div style={{ position: "relative", width: "250px", marginRight: "20px", marginLeft: "20px" }}>
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: 500,
                          color: "black",
                          marginLeft: "10px"
                        }}
                      >
                        Employees
                      </span>
                      <ScrollableDropdown
                        width={250}
                        label={selectedEmployee.first_name ? `${selectedEmployee?.first_name} ${selectedEmployee?.last_name || ""}` : "Select Employee"}
                        items={filteredEmployeeList}
                        getKey={e => e.id}
                        getLabel={e => `${e.first_name} ${e.last_name}`}
                        onSelect={this.handleSelectEmployee}
                        enableSearch={true}
                        onSearch={this.getEmployeeList}
                      />
                    </div>
                  </div>

                  <div style={{ position: "relative", width: "250px" }} ref={this.goalCycleDropdownRef}>
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: 500,
                          color: "black",
                          marginLeft: "10px"
                        }}
                      >
                        Goal Cycle
                      </span>
                      <ScrollableDropdown
                        width={250}
                        label={selectedTimeframe.title || "Goal Cycle"}
                        items={filteredGoalCycles}
                        getKey={g => g.id}
                        getLabel={g => g.title}
                        enableSearch={true}
                        onSelect={this.handleSelectTimeframe}
                      />
                    </div>
                  </div>
                </Flexbox>
              </Flexbox>

              <Flexbox flexDirection="column" className="push-20-t">
                <div>
                  {isLoadingGoals ? (
                    <div style={{ display: "flex", justifyContent: "center", padding: "40px 0" }}>
                      <LoadingIndicator size={30} />
                    </div>
                  ) : ((goalList && goalList.length > 0) || (cascadingGoalList && cascadingGoalList.length > 0)) ? (

                    <>

                      {cascadingGoalList && cascadingGoalList.length > 0 && (
                        <div>
                          <h3>Cascading Goals</h3>
                          <CascadingGoalsList cascadingGoalList={cascadingGoalList}
                            getStatusColor={this.getStatusColor}
                            getDaysLeft={this.getDaysLeft}
                            handleEditGoal={this.handleEditGoal}
                            canEditEmployeeGoal={this.canEditEmployeeGoal}
                            initiatedBy={'team'}
                            selectedTimeframe={selectedTimeframe}
                            onGoalLinked={() => this.fetchGoalsForSelectedEmployeeCycle(false)}
                            getActiveAccountId={this.getActiveAccountId}
                            currentPageEmployeeId={selectedEmployee.id}
                          />
                        </div>
                      )}

                      {goalList && goalList.length > 0 && <h3>Goals</h3>}
                      {goalList.map(goal => {
                        const subGoals = this.state.subGoalsByGoalId?.[goal.id] || [];
                        return (
                          <Card key={goal.id} style={{ marginBottom: "10px" }}>
                            <Flexbox flexDirection="row">
                              <Flexbox flexDirection="column">
                                <div className="goal-icon-box" role="img" aria-label="goal-icon">
                                  <img src={goalIcon} alt={"goalIcon"}></img>
                                </div>
                              </Flexbox>

                              {/* Left Section: Title + Description */}
                              <Flexbox flexDirection="column" style={{ flex: 1, paddingLeft: "12px" }}>
                                <Flexbox alignItems="center" gap="8px" style={{ marginBottom: "8px" }}>
                                  <span onClick={() => this.handleEditGoal(goal)} className="goal-title">
                                    {goal.title}
                                  </span>
                                  {goal.user_comment && (
                                    <Tooltip portalContainer={document.body} content={goal.user_comment} placement="top">
                                      <div style={{ cursor: "pointer", marginTop: '5px' }}>
                                        <img
                                          src={Comment1}
                                          alt="comment icon"
                                          style={{ width: 20, height: 20, marginRight: '5px' }}
                                        />
                                      </div>
                                    </Tooltip>)}
                                  {goal.goal_comment && (
                                    <Tooltip portalContainer={document.body} content={goal.goal_comment} placement="top">


                                      <div style={{ cursor: "pointer", marginTop: '5px' }}>
                                        <img
                                          src={Comment2}
                                          alt="comment icon"
                                          style={{ width: 20, height: 20, marginRight: '5px' }}
                                        />
                                      </div>
                                    </Tooltip>)}
                                </Flexbox>
                                <Tooltip
                                  portalContainer={document.body}
                                  content={goal.description}
                                  placement="top"
                                  popoverClassName="goal-description-tooltip"
                                  disabled={!goal.description}
                                >
                                  <p className="goal-description">
                                    {this.getDescriptionPreview(goal.description)}
                                  </p>
                                </Tooltip>

                                <Flexbox flexDirection="row" gap="16px" className="weitage-progres-row" alignItems="center">
                                  <Flexbox flexDirection="row" display="flex" alignItems="center" gap="8px">
                                    <Tooltip portalContainer={document.body} content={"Weightage"} placement="top">
                                      <img
                                        src={Weightage}
                                        alt="weightage icon"
                                        style={{ width: 20, height: 20, marginRight: '5px', marginTop: '4px' }}
                                      />
                                    </Tooltip>
                                    <span className="weight-value weight-value-fixed ">{goal.goal_weight}</span>
                                  </Flexbox>
                                  <Divider className="push-10-l push-10-r"></Divider>
                                  <Flexbox flexDirection="row" display="flex" alignItems="center" gap="8px">
                                    <Tooltip portalContainer={document.body} content={"Days left"} placement="top">
                                      <img
                                        src={TimeLeft}
                                        alt="time left icon"
                                        style={{ width: 20, height: 20, marginRight: '5px', marginTop: '4px' }}
                                      />
                                    </Tooltip>
                                    <span className="weight-title days-left-fixed "> {this.getDaysLeft(goal)}</span>
                                  </Flexbox>
                                  <Divider className="push-10-l push-10-r"></Divider>

                                  {goal?.file_url &&
                                    <>
                                      <Flexbox flexDirection="row" display="flex" alignItems="center" gap="8px">
                                        <Tooltip portalContainer={document.body} content={goal.file_name || "Attached File"} placement="top">
                                          <div>
                                            <a href={goal.file_url} target="_blank" rel="noopener noreferrer" style={{ color: "#106ba3", textDecoration: "underline", cursor: "pointer" }}>
                                              <Icon icon="paperclip" size={12} />
                                            </a>
                                          </div>
                                        </Tooltip>
                                      </Flexbox>
                                      <Divider className="push-10-l push-10-r"></Divider>
                                    </>
                                  }

                                  <Tooltip portalContainer={document.body} content={"Progress"} placement="top">
                                    <img
                                      src={Progress}
                                      alt="progress icon"
                                      style={{ width: 20, height: 20, marginRight: '5px', marginTop: '4px' }}
                                    />
                                  </Tooltip>
                                  <GoalProgressRow goal={goal} subGoals={subGoals} accountId={this.getActiveAccountId()} />
                                </Flexbox>
                              </Flexbox>

                              {/* Right Section: Status + Actions */}
                              <Flexbox
                                flexDirection="row"
                                alignItems="flex-start"
                                justifyContent="space-between"
                                style={{ minWidth: "140px" }}
                              >
                                <div
                                  //className="push-10-l push-10-r"
                                  style={{
                                    border: `1px solid ${this.getStatusColor(goal.goal_progress_states)} `,
                                    borderRadius: "20px",
                                    padding: "6px 18px"
                                  }}
                                >
                                  <span style={{ fontWeight: "400", color: this.getStatusColor(goal.goal_progress_states) }}>{goal.goal_progress_states}</span>
                                </div>

                                <Flexbox gap="4px">
                                  <Button
                                    icon={<svg width="21" height="21" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M7.63704 21.2615H2.51904L2.69554 16.1885L16.1595 3.1285C16.4168 2.87888 16.761 2.73903 17.1194 2.73847C17.4779 2.73791 17.8225 2.87669 18.0805 3.1255L21.059 5.9975C21.1916 6.12538 21.2973 6.27848 21.3698 6.44778C21.4424 6.61708 21.4803 6.79918 21.4815 6.98337C21.4827 7.16756 21.447 7.35012 21.3766 7.52033C21.3062 7.69053 21.2025 7.84495 21.0715 7.9745L7.63704 21.2615ZM3.47254 20.3385H7.25854L20.4235 7.3195C20.4672 7.27634 20.5018 7.22488 20.5253 7.16815C20.5488 7.11142 20.5607 7.05056 20.5603 6.98916C20.56 6.92776 20.5473 6.86705 20.5231 6.81061C20.499 6.75416 20.4637 6.70313 20.4195 6.6605L17.441 3.7885C17.3552 3.70538 17.2403 3.65891 17.1208 3.65891C17.0013 3.65891 16.8864 3.70538 16.8005 3.7885L3.60054 16.5885L3.47254 20.3385Z" fill="#707070" />
                                      <path d="M18.8589 9.5245L14.4719 5.21L15.2029 4.491L19.5899 8.8055L18.8589 9.5245Z" fill="#707070" />
                                    </svg>
                                    }
                                    minimal onClick={() => this.handleEditGoal(goal)} />
                                </Flexbox>
                              </Flexbox>
                            </Flexbox>
                            <div
                              style={{
                                marginTop: 8,
                                fontSize: 13,
                                color: "#6f5bd7",
                                cursor: "pointer",
                                paddingLeft: 50
                              }}
                              onClick={() =>
                                this.setState(prev => ({
                                  openSubGoals: {
                                    ...prev.openSubGoals,
                                    [goal.id]: !prev.openSubGoals[goal.id]
                                  }
                                }))
                              }
                            >
                              <Icon
                                icon={this.state.openSubGoals[goal.id] ? "chevron-down" : "chevron-right"}
                                size={14}
                              />
                              {(this.state.subGoalsByGoalId?.[goal.id] || []).length} Sub-goals
                            </div>
                            <GoalCollapse isOpen={this.state.openSubGoals[goal.id]} keepChildrenMounted>
                              <div style={{ paddingLeft: "32px", marginTop: "10px" }}>
                                {(this.state.subGoalsByGoalId?.[goal.id] || []).map(sub => (
                                  <Card
                                    key={sub.id}
                                    style={{
                                      marginBottom: "16px",
                                      borderRadius: "8px",
                                      border: "1px solid #d6d6d6",
                                      padding: "16px",
                                      boxShadow: "none"
                                    }}
                                  >
                                    <Flexbox flexDirection="row">
                                      {/* Icon */}
                                      <Flexbox>
                                        <div className="goal-icon-box">
                                          <img src={Subgoal} alt="subgoalIcon" />
                                        </div>
                                      </Flexbox>

                                      {/* CONTENT */}
                                      <Flexbox flexDirection="column" style={{ flex: 1, paddingLeft: "12px" }}>
                                        <Flexbox alignItems="center" gap="8px" style={{ marginBottom: "8px" }}>
                                          <span className="goal-title">
                                            {sub.title}
                                          </span>
                                          {sub.user_comment && (
                                            <Tooltip portalContainer={document.body} content={sub.user_comment} placement="top">

                                              <div style={{ cursor: "pointer", marginTop: '5px' }}>
                                                <img
                                                  src={Comment1}
                                                  alt="comment icon"
                                                  style={{ width: 20, height: 20, marginRight: '5px' }}
                                                />
                                              </div>

                                            </Tooltip>)}
                                          {sub.goal_comment && (
                                            <Tooltip portalContainer={document.body} content={sub.goal_comment} placement="top">
                                              <div style={{ cursor: "pointer", marginTop: '5px' }}>
                                                <img
                                                  src={Comment2}
                                                  alt="comment icon"
                                                  style={{ width: 20, height: 20, marginRight: '5px' }}
                                                />
                                              </div>
                                            </Tooltip>)}
                                        </Flexbox>
                                        <Tooltip
                                          content={sub.description}
                                          placement="top"
                                          popoverClassName="goal-description-tooltip"
                                          disabled={!sub.description}
                                        >
                                          <p className="goal-description">
                                            {this.getDescriptionPreview(sub.description)}
                                          </p>
                                        </Tooltip>
                                        <Flexbox flexDirection="row" gap="16px" alignItems="center">
                                          <Tooltip portalContainer={document.body} content={"Progress"} placement="top">
                                            <img
                                              src={Progress}
                                              alt="progress icon"
                                              style={{ width: 20, height: 20, marginRight: '5px', marginTop: '4px' }}
                                            />
                                          </Tooltip>
                                          <GoalProgressRow goal={sub} accountId={this.getActiveAccountId()} />
                                        </Flexbox>
                                      </Flexbox>
                                    </Flexbox>
                                    <MilestoneList
                                      key={`${selectedEmployee.id}:${selectedTimeframe.id}:${sub.id}`}
                                      subGoal={sub}
                                      goalSettingId={goal.goal_setting_id || selectedTimeframe.id}
                                      userId={selectedEmployee.id}
                                      editable={false}
                                      onRefresh={() => this.fetchGoalsForSelectedEmployeeCycle(false)}
                                    />
                                  </Card>
                                ))}
                              </div>
                            </GoalCollapse>
                          </Card>
                        );
                      })}
                    </>


                  ) : (
                    <div className="push-30-t">
                      <BlankPage
                        title={"No Goals Yet"}
                        description={`You haven't set any goals. Create your first goal to track your progress and stay on top of your priorities.`}
                      />
                    </div>
                  )}
                </div>
              </Flexbox>

              <Drawer
                portalContainer={document.body}
                size={"40%"}
                isOpen={isDrawerOpen}
                onClose={() => this.setState({ isDrawerOpen: false })}
                className="goal-edit-drawer"
                title="Add Goal"
              >
                {editingGoal && (
                  <div className="goal-edit-drawer-content">
                    <Flexbox flexDirection="row" flexGrow={1} padding="20px">
                      <Flexbox flexDirection="column" flexGrow={1} className="bp3-form-content">
                        <FormGroup className="input-label push-10-b push-10-t" label="Goal Title" labelFor="">
                          <input
                            placeholder="Title"
                            className="bp3-input bp3-control-no-margin push-10-b"
                            type="text"
                            name="title"
                            value={editingGoal.title}
                            disabled={true}
                            style={{ border: "1px solid #e1e1e1", boxShadow: "none", height: "38px", width: "100%" }}
                          />
                        </FormGroup>

                        <FormGroup label="Goal Description" className="input-label push-10-b">
                          <TextArea
                            name="description"
                            placeholder="Description"
                            rows={6}
                            value={editingGoal.description}
                            className="push-10-t push-10-b"
                            style={{ resize: "none", border: "1px solid #e1e1e1", boxShadow: "none", width: "100%" }}
                            disabled={true}
                          // disabled={!selectedTimeframe.is_editable}
                          />
                        </FormGroup>

                        <FormGroup className="input-label push-10-b" label="Comment" labelFor="">
                          <input
                            placeholder="Comment"
                            className="bp3-input push-10-t push-10-b "
                            type="text"
                            name="goal_comment"
                            value={editingGoal.goal_comment}
                            onChange={e => this.handleGoalInputChange(editingGoal.id, "goal_comment", e.target.value)}
                            style={{ border: "1px solid #e1e1e1", boxShadow: "none", width: '100%' }}
                            disabled={!selectedTimeframe.is_editable}
                          />
                        </FormGroup>

                        <FormGroup style={{ width: "100%" }}>
                          <Flexbox flexDirection="row" alignItems="center" gap="10px" className="push-10-b">
                            <span>Goal Progress:</span>
                            <GoalProgressRow goal={editingGoal} accountId={this.getActiveAccountId()} barWidth="65%" showMatrix={false} barStyle={{ marginTop: 0 }} />
                          </Flexbox>
                        </FormGroup>

                        <FormGroup label="Goal Weightage" className="push-10-b push-10-t">
                          <input
                            name="goal_weight"
                            placeholder="Weight"
                            value={editingGoal.goal_weight}
                            buttonPosition="none"
                            disabled={true}
                            style={{ height: "34px", width: "150px", paddingLeft: '5px' }}
                          />
                        </FormGroup>

                        <FormGroup label="Goal End Date" className="max-width push-20-b">
                          <div className="flex flex-row">
                            <input
                              type="date"
                              value={editingGoal.goal_end_at ? moment.utc(editingGoal.goal_end_at).format("YYYY-MM-DD") : moment.utc(selectedTimeframe.end_date).format("YYYY-MM-DD")}
                              disabled={true}
                              placeholder="End Date"
                              className={`${Classes.INPUT}`}
                            //className="bp4-input"
                            />

                          </div>
                        </FormGroup>

                        <FormGroup className="input-label push-10-b" label="Employee Comment" labelFor="">
                          <input
                            placeholder="Comment"
                            className="bp3-input push-10-b "
                            type="text"
                            name="goal_comment"
                            value={editingGoal.user_comment}
                            disabled={true}
                            style={{ border: "1px solid #e1e1e1", boxShadow: "none", width: '100%' }}
                          />
                        </FormGroup>

                        <FormGroup label="Progress Status" className="push-10-b" style={{ width: '40%' }}>
                          <GoalProgressStatusBadge goal={editingGoal} style={{ marginLeft: 0 }} />
                        </FormGroup>

                        {selectedTimeframe.is_goal_progress_status && goalStatusList.length > 0 && (
                          <FormGroup label="Progress Status" className="push-10-b" style={{ width: '40%' }}>
                            <HTMLSelect
                              fill
                              value={editingGoal.goal_progress_state_id || ""}
                              onChange={e => this.handleGoalInputChange(editingGoal.id, "goal_progress_state_id", e.target.value)}
                              options={[
                                { label: "Select Status", value: "" },
                                ...goalStatusList
                                  .map(status => ({
                                    label: status.status_name,
                                    value: status.id
                                  }))
                              ]}
                              disabled={!selectedTimeframe.is_editable}
                            />
                          </FormGroup>
                        )}

                        {!selectedTimeframe.is_editable && (
                          <div className="editable-warning-box">
                            <p className="editable-warning-title">Your goal has been published and locked</p>
                            <p className="editable-warning-description">
                              You can no longer edit the goal details. Only progress updates are allowed at this stage. If you need to
                              request changes, please contact your HR team or manager.
                            </p>
                          </div>
                        )}

                        <div style={{ marginTop: "10px" }}>
                          <FilledButton text={"Save"} onClick={() => this.handleSubmit(editingGoal.id)} />
                          <TextButton text={"Cancel"} onClick={() => this.handleCancelGoal(editingGoal.id)} />
                        </div>
                      </Flexbox>
                    </Flexbox>
                  </div>
                )}
              </Drawer>
            </Flexbox>
          </Flexbox>
        </ErrorBoundary>
      </ThemeWrapper>
    );
  }
}
